import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined, SearchOutlined, PlusCircleOutlined } from '@ant-design/icons';

import {
  Input,
  Row,
  Typography,
  Card,
  Select,
  Form,
  Col,
  Descriptions,
  Divider,
  Button,
  Modal,
  Space,
  Spin,
  Transfer
} from "antd";

//OTHER IMPORTS
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";

import MainLayout from '../../../../components/layouts/MainLayout';
import TopContent from '../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../group.config";
import CustomButton from '../../../../components/custom/CustomButton';
import styles from '../../../../assets/styles/styles';


const { Text, Title } = Typography

const TransferCustomers = (props) => {

  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isGroupSelected, setIsGroupSelected] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [clientOptions, setClientOptions] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [clientDetails, setClientDetails] = useState([]);
  const [client, setClient] = useState([]);
  const [groupDetails, setGroupDetails] = useState(null);
  const [currentGroupDetails, setCurrentGroupDetails] = useState({});

  useEffect(() => {
    getTemplate();
  }, []);

  function getTemplate() {

    const params = {
      associations: "clientMembers"
    }
    const url = `${apiConfig.Groups}/${state.id}`;

    let body = {
      session,
      params
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        setClientDetails(objList);

        const tempClientsOptions = [];

        objList?.clientMembers?.forEach((element) => {
          tempClientsOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        setClientOptions(tempClientsOptions);
        setIsLoading(false);
      }
    });
  }

  function onCancel() {
    navigate("/detail-group", { state: state });
  }

  const renderItem = (item) => {
    return {
      label: item.label,
      value: item.value,
    };
  };

  const handleChange = (newTargetKeys, direction, moveKeys) => {
    let tempClientObj = []

    clientOptions.forEach((element) =>
      tempClientObj.push({
        id: element.value
      }))
    const clientObj = moveKeys.map((key, index) =>
      tempClientObj.find((item) => item.id === key))
    setClient(clientObj)
    setSelectedClients(newTargetKeys);
  };

  const onSubmit = (formValues) => {

    formValues.destinationGroupId = currentGroupDetails.id
    formValues.clients = client

    const params = {
      command: "transferClients",
    }

    const url = `${apiConfig.Groups}/${state.id}`;

    const body = {
      ...formValues,
      method: "POST",
      session,
      params,
      locale: "en"
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);

      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.transferCustomerMsg);
        navigate("/detail-group", { state: state });

        //STOP LOAD
        setIsLoading(false);
      }
    });

  };


  const items = [
    {
      key: "1",
      label: labelConfig.id,
      children: groupDetails ? currentGroupDetails?.id : "-",
      span: 3,
    },
    {
      key: "2",
      label: labelConfig.name,
      children: groupDetails ? currentGroupDetails?.name : "-",
      span: 3,
    },
    {
      key: "3",
      label: labelConfig.office,
      children: groupDetails ? currentGroupDetails?.office : "-",
      span: 3,
    },
  ];

  return (

    <MainLayout isEnableRightSidebar={true} >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.transferClients}
        pageItems={staticConfig.transferClientsBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                >
                  Back
                </Text>
              </Button>

            </Row>
          }
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmit}
          >

            <Row >
              <Divider orientation="left" orientationMargin="0">
                {labelConfig.clients}
              </Divider>
              <Col span={24} style={{ padding: "0px 8px" }}>
                <Transfer
                  titles={[labelConfig.availableClients, labelConfig.selectedClients]}
                  dataSource={clientOptions}
                  listStyle={{ width: 400 }}
                  targetKeys={selectedClients}
                  onChange={handleChange}
                  render={renderItem}
                  rowKey={(record) => record.value}
                />
              </Col>
            </Row>

            <Row>
              <Col span={8} style={{ padding: "0px 8px", marginTop: "25px" }}>
                <Form.Item
                  label={labelConfig.inheritGroupLoanOfficer}
                  name="inheritDestinationGroupLoanOfficer"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.option,
                      "select"
                    )}
                    options={staticConfig.yesOrNo}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.groupInfo}
                </Title>
              </Divider>

              <GroupInformationModal
                session={session}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                clientDetails={clientDetails}
                isGroupSelected={isGroupSelected}
                setIsGroupSelected={setIsGroupSelected}
                items={items}
                groupDetails={groupDetails}
                setGroupDetails={setGroupDetails}
                setCurrentGroupDetails={setCurrentGroupDetails}
                currentGroupDetails={currentGroupDetails}
                state={state}
              />
            </Row>

            <Row>
              {isGroupSelected && (
                <Descriptions
                  bordered
                  column={{
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 2,
                    xl: 2,
                    xxl: 2,
                  }}
                  style={{ marginTop: 10, marginBottom: 20, width: 510 }}
                  items={items}
                />
              )}
            </Row>
            <Row>
              <Divider />
              {BOM.HasPermission("TRANSFERCLIENTS_GROUP") &&
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>

        </Card>
      </Spin>

    </MainLayout>

  )
}
export default TransferCustomers

const GroupInformationModal = (props) => {
  const {
    session,
    items,
    isModalOpen,
    setIsModalOpen,
    clientDetails,
    isGroupSelected,
    setIsGroupSelected,
    groupDetails,
    setGroupDetails,
    setCurrentGroupDetails,
    state
  } = props;

  const [useForm] = Form.useForm();
  const [groupData, setGroupData] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isID, setIsID] = useState(false);
  const [isName, setIsName] = useState(false);
  const [searchParam, setSearchParam] = useState("");


  const onSearch = (objParam) => {

    if (!searchParam.trim()) {
      BOM.AlertMsg(cnt.WARNING, "Search parameter is required");
      return;
    }

    const params = {
      officeId: objParam ? objParam.officeId : null,
      orderBy: "name",
      sortOrder: "ASC",
    };

    if (isNaN(searchParam)) {
      params.name = searchParam.trim()
      setIsName(true)
    } else {
      params.groupId = searchParam
      setIsID(true)
    }

    const url = `${apiConfig.Groups}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);

    // return
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);

      } else {
        const objList = res;
        let tempGroupData = [];
        let tempGroupDetails = [];

        objList?.filter((item) => item.id !== state.id)?.forEach((element) => {
          tempGroupData.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.forEach((element) => {
          tempGroupDetails.push({
            key: element.id,
            id: element.id,
            name: element.name,
            office: element.officeName,
          });
        });

        if (tempGroupData === undefined) {
          BOM.AlertMsg(cnt.DANGER, "No matching group found.");
          setShowDetailsForm(false);
          setIsLoading(false);
          return;
        }

        // const filterGroupById = tempGroupData.filter((item) => item?.value === searchParam)

        setGroupOptions(tempGroupData)
        setGroupDetails(tempGroupDetails)
        setShowDetailsForm(true);
        setIsLoading(false);
        useForm.resetFields();

      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleGroupSave = () => {
    setIsModalOpen(false);
  };

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    if (!searchKey) {
      return;
    }
    setSearchParam(searchKey);
  }

  const onChangeGroup = (customerParam) => {
    const currentGroupDetails = groupDetails?.find(
      (item) => item.id === customerParam
    );
    setCurrentGroupDetails(currentGroupDetails);
    setIsGroupSelected(true);

  };

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        className="of-primaryBtnColor"
        onClick={showModal}
        icon={<PlusCircleOutlined />}
      // disabled={isGroupSelected}
      >
        {labelConfig.addGroup}
      </Button>

      <Modal
        title="Group Information Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitLimit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleGroupSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">

          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Space.Compact>
                <div>
                  <Input
                    onChange={handleSearchInTable}
                    placeholder="Search by Group Name or Group ID"
                    style={{ width: 460 }}
                    allowClear
                  />
                </div>
                <Button
                  type="primary"
                  className="of-primaryBtnColor"
                  onClick={() => onSearch(clientDetails)}
                >
                  <SearchOutlined />
                </Button>
              </Space.Compact>
            </Col>
          </Row>
          {showDetailsForm && (
            <>
              <Row>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {labelConfig.selectGroup}
                  </Title>
                </Divider>
                <Col span={12} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.group}
                    name={"destinationGroupId"}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.group),
                      },
                    ]}
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.group,
                        "select"
                      )}
                      options={groupOptions}
                      showSearch
                      onChange={onChangeGroup}
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}

          {isGroupSelected && (
            <Descriptions
              bordered
              column={{
                xs: 1,
                sm: 2,
                md: 2,
                lg: 2,
                xl: 2,
                xxl: 2,
              }}
              style={{ marginTop: 10, marginBottom: 20 }}
              items={items}
            />
          )}
        </Spin>
      </Modal>
    </Row>
  );
};